const TEXT = "text";
const TEXTAREA = "textarea";

const TYPES = {
  TEXT,
  TEXTAREA,
};

export default TYPES;
